<template>
    <div class="row">
        <div class="col-md-12">
            <div class="m-3 upload-doc" v-if="$can('create-files') && !showOnly">
                <div class="row">
                    <p class="col-sm-4">{{ uLang('app.add_new_document') }}</p>
                    <file-upload
                        :entityType="entityType"
                        :entityId="entityId"
                        :allowDescription="true"
                        @updateSuccess="handleUploadSuccess($event)"
                        @uploadSuccess="handleUploadSuccess($event)"
                        @uploadFailed="handleUploadFailure($event)"
                        class="col-sm-8 text-right"
                    />
                </div>
            </div>
            <documents-table
                :entityType="entityType"
                :entityId="entityId"
                :files="files"
                @fileUpdated="handleUpdateSuccess"
                @fileDeleted="handleDeleteSuccess"
            />
        </div>
    </div>
</template>

<script>
    import { DocumentsTable, FileUpload } from "~/components/tabs/documents"

    export default {
        name: 'DocumentsTab',

        components: { FileUpload, DocumentsTable },

        data() {
            return {
                files: [],
            }
        },

        props: {
            entityType: {
                required: true,
                type: String,
            },
            entityId: {
                required: true,
                type: Number,
            },
            showOnly: {
                type: Boolean,
                default: false
            }
        },

        mounted() {
            this.retrieveFiles();
        },

        methods: {
            handleUploadSuccess(data) {
                this.retrieveFiles();
                this.$snotify.info(uLang('app.entity_created', { entity: uLang('app.document') }),
                    uLang('app.created'));
            },
            handleUploadFailure(data) {
                if(Array.isArray(data)) {
                    data.forEach((error) => {
                        this.$snotify.error(error);
                    });

                    return;
                }

                this.$snotify.error(data)
            },

            handleUpdateSuccess() {
                this.retrieveFiles();
                this.$snotify.info(uLang('app.entity_updated', { entity: uLang('app.document') }),
                    uLang('app.saved'));
            },

            handleDeleteSuccess() {
                this.retrieveFiles();
                this.$snotify.info(uLang('app.entity_removed', { entity: uLang('app.document') }),
                    uLang('app.deleted'));
            },

            async retrieveFiles() {
                const { data } = await window.axios.get(route('document.index', {
                    resource: this.entityType,
                    resource_id: this.entityId,
                }))

                this.files = data;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .upload-doc {
        background-color: #f3f1f6;
        padding: 8px 15px;
        border: 1px solid #eceeef;
        p {
            margin: 0;
            line-height: 20px;
            font-weight: 500;
            letter-spacing: 0px;
        }
    }
</style>
